import { render, staticRenderFns } from "./settingFortunellaVenosaRule.vue?vue&type=template&id=27abd49c&scoped=true&"
import script from "./settingFortunellaVenosaRule.vue?vue&type=script&lang=js&"
export * from "./settingFortunellaVenosaRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27abd49c",
  null
  
)

component.options.__file = "settingFortunellaVenosaRule.vue"
export default component.exports